import React from 'react';
import { HashRouter as Router, Route, Routes, Link, Navigate } from 'react-router-dom';
import { PrivateRoute } from '../_components';
import { HomePage } from '../Page/HomePage';
import { DataManagement } from '../Page/DataManagement';
import Planning, { MRP, ClearToBuild } from '../Page/Planning';
import { MasterData } from '../Page/MasterData';
import { ToolingMasterData, ToolingMaintenanceSummary, ToolingMaintenanceForm, ToolingTPM, TpmChecklistForm, TpmMaintenanceDetail } from '../Page/Tooling';
import { InspectionList, TestList } from '../Page/QA';
import { IncomingMaster, IncomingMasterForm } from '../Page/IncomingMaster';
import { IncomingSummary, IncomingSummaryReport } from '../Page/IncomingSummary';
import { InprogressMaster, InprogressMasterForm } from '../Page/InprogressMaster';
import { InprogressSummary, InprogressSummaryReport } from '../Page/InprogressSummary';
import { OutgoingMaster, OutgoingMasterForm } from '../Page/OutgoingMaster';
import { OutgoingSummary, OutgoingSummaryReport } from '../Page/OutgoingSummary';
import { FpboSummary, FpboSummaryReport } from '../Page/FpboSummary';
import { LpboSummary, LpboSummaryReport } from '../Page/LpboSummary';
import { FaiMaster, FaiMasterForm } from '../Page/FaiMaster';
import { FaiSummary, FaiSummaryReport } from '../Page/FaiSummary';
import { WaitingForInspection } from '../Page/WaitingForInspection';
import { Upload } from '../Page/Upload';
import { BomList } from '../Page/BomList';
import { NewPartCreation } from '../Page/NewPartCreation';
import { RevisionHistory } from '../Page/RevisionHistory';
import { Setting, ChangePassword, Profile, Targets, CurrencySettings, UserSettings } from '../Page/Setting';
import { MasterRawMaterial, MasterFinishedGoods, MasterLocation, ActivateStorage, ReceivingSummary, ReceivingSummaryReport, RMTransferSummary, RMTransferSummaryReport, FGTransferSummary, FGTransferSummaryReport, FGDeliverySummary, FGDeliverySummaryReport, ScrappingSummary, ScrappingSummaryReport, InventoryStatusOverview, BomUsageByJobReport, InventoryStatusReport } from '../Page/InventoryManagement';
import { HourlyReport } from '../Page/HourlyReport';
import { JobOrderSummaryReport } from '../Page/JobOrderSummaryReport';
import { DailyOEEReport } from '../Page/DailyOEEReport';
import { MonthlyOEEReport } from '../Page/MonthlyOEEReport';
import { DailyProductivityReport } from '../Page/DailyProductivityReport';
import { MonthlyProductivityReport } from '../Page/MonthlyProductivityReport';
import { RMWarehouseOccupancyReport } from '../Page/RMWarehouseOccupancyReport';
import { FGWarehouseOccupancyReport } from '../Page/FGWarehouseOccupancyReport';
import { LoginPage } from '../Page/LoginPage';
import { AdminDashboard } from '../Page/AdminDashboard';
import { DocCon } from '../Page/DocCon';
import config from '../../config';
import {
    canAccessInventoryPortalItem, canAccessToolingManagement,
    canAccessSalesModule, canAccessPurchaseModule,
    isBusinessUnitUser, isShippingUser, isBusinessUnitManager,
    isPurchasingUser, isPurchasingManager,
    canAccessAccounting, isSuperAdmin,
} from '../utils/roleConstants';
import pushNotificationManager from '../utils/pushNotifications';
import { DOC_TYPE_IDS } from '../utils/docTypeConstants';
import {
    getFinanceApprovalList,
    getPurchaseApprovalList,
    getSalesApprovalList,
} from '../_services/approval.service';
import Sidebar from '../_components/Sidebar';
import { startDataTableFreezeManager } from '../_components/Shared/dataTableFreeze';
import AIChatWidget from '../_components/AIChat';
// Sales
import Quotations from '../Page/Sales/Quotations';
import QuotationDetails from '../Page/Sales/QuotationDetails';
import SalesOrders from '../Page/Sales/SalesOrders';
import SalesOrderDetails from '../Page/Sales/SalesOrderDetails';
import Invoices from '../Page/Sales/Invoices';
import InvoiceDetails from '../Page/Sales/InvoiceDetails';
import DeliveryOrders from '../Page/Sales/DeliveryOrders';
import DeliveryOrderDetails from '../Page/Sales/DeliveryOrderDetails';
import SalesApprovals from '../Page/Sales/Approval/SalesApprovals';
// Purchasing
import PurchaseOrders from '../Page/Purchasing/PurchaseOrders';
import PurchaseOrderDetails from '../Page/Purchasing/PurchaseOrderDetails';
import PurchasingApprovals from '../Page/Purchasing/Approval/PurchasingApprovals';
// Finance
import DirectPurchaseInvoices from '../Page/Finance/DirectPurchaseInvoices';
import DirectPurchaseInvoiceDetails from '../Page/Finance/DirectPurchaseInvoiceDetails';
import IndirectPurchaseInvoices from '../Page/Finance/IndirectPurchaseInvoices';
import IndirectPurchaseInvoiceDetails from '../Page/Finance/IndirectPurchaseInvoiceDetails';
import PaymentVouchers from '../Page/Finance/PaymentVouchers';
import PaymentVoucherDetails from '../Page/Finance/PaymentVoucherDetails';
import PurchaseCreditNotes from "../Page/Finance/PurchaseCreditNote";
import PurchaseCreditNoteDetails from "../Page/Finance/PurchaseCreditNoteDetails";
import PurchaseDebitNotes from "../Page/Finance/PurchaseDebitNote";
import PurchaseDebitNoteDetails from "../Page/Finance/PurchaseDebitNoteDetails";
import CreditNotes from '../Page/Finance/CreditNotes';
import CreditNoteDetails from '../Page/Finance/CreditNoteDetails';
import DebitNotes from '../Page/Finance/DebitNotes';
import DebitNoteDetails from '../Page/Finance/DebitNoteDetails';
import FinanceApprovals from '../Page/Finance/Approval/FinanceApprovals';
// Contact Maintenance
import Customers from '../Page/Sales/Customer/Customers';
import Suppliers from '../Page/Purchasing/Supplier/Suppliers';
import CustomerDetails from '../Page/Sales/Customer/CustomerDetails';
import SupplierDetails from '../Page/Purchasing/Supplier/SupplierDetails';
import Company from '../Page/Finance/Company/Company';
import ComingSoon from '../Page/ComingSoon';

/** Shown in the app footer (all pages). */
const APP_VERSION = '5.2.0';

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            navbar: false,
            pendingApprovalCount: 0,
            pendingCountsByType: {
                incoming: 0,
                outgoing: 0,
                inprogress: 0,
                fpbo: 0,
                lpbo: 0,
                fai: 0
            },
            pendingSalesCount: 0,
            pendingPurchaseCount: 0,
            pendingFinanceCount: 0,
            showInstallPrompt: false,
            deferredPrompt: null,
            isSafari: false,
            isIOS: false,
            showSafariInstructions: false,
        };
    }

    componentDidMount() {
        this.stopDataTableFreezeManager = startDataTableFreezeManager();

        // Detect Safari and iOS
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) ||
            /iPad|iPhone|iPod/.test(navigator.userAgent);
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
        const isStandaloneMode = window.matchMedia('(display-mode: standalone)').matches;

        // Check if Safari instructions were dismissed
        const safariDismissed = localStorage.getItem('pwa-safari-instructions-dismissed');
        const safariWasDismissed = safariDismissed && (Date.now() - parseInt(safariDismissed, 10) < 7 * 24 * 60 * 60 * 1000);

        this.setState({
            isSafari,
            isIOS,
            showSafariInstructions: isSafari && !isStandaloneMode && localStorage.getItem('user') !== null && !safariWasDismissed
        });

        // Check navbar state periodically
        this.interval = setInterval(() => {
            if (localStorage.getItem('user')) {
                this.setState({ navbar: true });
                // Show Safari instructions if user is logged in, not in standalone mode, and not dismissed
                if (isSafari) {
                    const safariDismissedCheck = localStorage.getItem('pwa-safari-instructions-dismissed');
                    const safariWasDismissedCheck = safariDismissedCheck && (Date.now() - parseInt(safariDismissedCheck, 10) < 7 * 24 * 60 * 60 * 1000);
                    const currentlyStandalone = window.matchMedia('(display-mode: standalone)').matches;
                    if (!currentlyStandalone && !safariWasDismissedCheck) {
                        this.setState({ showSafariInstructions: true });
                    } else {
                        this.setState({ showSafariInstructions: false });
                    }
                } else {
                    this.setState({ showSafariInstructions: false });
                }
            }
            else {
                this.setState({ navbar: false, showSafariInstructions: false });
            }
        }, 100);

        // Fetch pending approval count on mount
        if (localStorage.getItem('user')) {
            this.fetchPendingApprovalCount();
            this.fetchPendingSalesCount();
            this.fetchPendingPurchaseCount();
            this.fetchPendingFinanceCount();
        }

        // Listen for custom event to refresh pending approval counts
        // This is triggered when records are approved/rejected in summary pages
        this.refreshCountsHandler = () => {
            if (localStorage.getItem('user')) {
                this.fetchPendingApprovalCount();
                this.fetchPendingSalesCount();
                this.fetchPendingPurchaseCount();
                this.fetchPendingFinanceCount();
            }
        };
        window.addEventListener('refreshPendingApprovalCounts', this.refreshCountsHandler);

        // Initialize push notifications if user is logged in
        if (localStorage.getItem('user')) {
            this.initializePushNotifications();
        }

        // Check if app is already installed FIRST (before setting up listeners)
        const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
        if (isStandalone) {
            console.log('PWA: App is already installed (standalone mode)');
            this.setState({ showInstallPrompt: false });
        }

        // Check if user dismissed recently (within 7 days)
        const dismissed = localStorage.getItem('pwa-install-dismissed');
        let wasDismissed = false;
        if (dismissed) {
            const dismissedTime = parseInt(dismissed, 10);
            const sevenDays = 7 * 24 * 60 * 60 * 1000;
            if (Date.now() - dismissedTime < sevenDays) {
                wasDismissed = true;
                console.log('PWA: Install prompt was dismissed recently');
                this.setState({ showInstallPrompt: false });
            } else {
                // Dismissal expired, clear it
                localStorage.removeItem('pwa-install-dismissed');
                console.log('PWA: Previous dismissal expired');
            }
        }

        // Handle PWA install prompt
        this.handleBeforeInstallPrompt = (e) => {
            console.log('PWA: beforeinstallprompt event fired');

            // Check current state (not just initial state)
            const currentlyStandalone = window.matchMedia('(display-mode: standalone)').matches;
            const recentlyDismissed = (() => {
                const dismissed = localStorage.getItem('pwa-install-dismissed');
                if (!dismissed) return false;
                const dismissedTime = parseInt(dismissed, 10);
                const sevenDays = 7 * 24 * 60 * 60 * 1000;
                return Date.now() - dismissedTime < sevenDays;
            })();

            // Don't show if already installed or recently dismissed
            if (currentlyStandalone) {
                console.log('PWA: Skipping prompt (app is already installed)');
                return;
            }

            if (recentlyDismissed) {
                console.log('PWA: Skipping prompt (was recently dismissed)');
                return;
            }

            // Prevent the mini-infobar from appearing on mobile
            e.preventDefault();
            // Stash the event globally and in state
            window.deferredPrompt = e;
            this.setState({
                deferredPrompt: e,
                showInstallPrompt: true
            });
            console.log('PWA: Install prompt is now available and visible');
        };

        // Listen for app installed event
        this.handleAppInstalled = () => {
            console.log('PWA: App was installed');
            window.deferredPrompt = null;
            this.setState({
                deferredPrompt: null,
                showInstallPrompt: false
            });
        };

        // Check if deferredPrompt already exists (set before component mounted)
        if (window.deferredPrompt && !isStandalone && !wasDismissed) {
            console.log('PWA: Found existing deferredPrompt');
            this.setState({
                deferredPrompt: window.deferredPrompt,
                showInstallPrompt: true
            });
        }

        // Listen for custom event from index.jsx
        this.handlePWAInstallAvailable = () => {
            if (window.deferredPrompt && !isStandalone && !wasDismissed) {
                console.log('PWA: Received pwa-install-available event');
                this.setState({
                    deferredPrompt: window.deferredPrompt,
                    showInstallPrompt: true
                });
            }
        };

        window.addEventListener('beforeinstallprompt', this.handleBeforeInstallPrompt);
        window.addEventListener('appinstalled', this.handleAppInstalled);
        window.addEventListener('pwa-install-available', this.handlePWAInstallAvailable);

        // Debug: Log PWA installability status
        console.log('PWA Status:', {
            isStandalone,
            wasDismissed,
            hasDeferredPrompt: !!window.deferredPrompt,
            serviceWorkerSupported: 'serviceWorker' in navigator
        });

        // Add helper to window for debugging
        window.checkPWAStatus = () => {
            const status = {
                isStandalone: window.matchMedia('(display-mode: standalone)').matches,
                hasDeferredPrompt: !!window.deferredPrompt,
                showInstallPrompt: this.state.showInstallPrompt,
                dismissed: localStorage.getItem('pwa-install-dismissed'),
                serviceWorkerSupported: 'serviceWorker' in navigator,
                manifestLink: document.querySelector('link[rel="manifest"]')?.href
            };
            console.log('PWA Status Check:', status);
            return status;
        };

        // Helper to clear dismissal for testing
        window.clearPWADismissal = () => {
            localStorage.removeItem('pwa-install-dismissed');
            console.log('PWA dismissal cleared. Refresh page to see prompt if available.');
        };

        // Disable auto-refresh of pending approval count to reduce API calls
        // Uncomment below to enable (every 10 minutes)
        // this.countInterval = setInterval(() => {
        //     if (localStorage.getItem('user')) {
        //         this.fetchPendingApprovalCount();
        //     }
        // }, 600000); // 10 minutes = 600000ms
        this.countInterval = null; // Disabled to prevent constant API calls
    }

    initializePushNotifications = async () => {
        try {
            const result = await pushNotificationManager.initialize();
            if (result.subscribed) {
                console.log('Push notifications initialized successfully');
            } else if (result.permission === 'denied') {
                // Permission was denied - don't log as error, just info
                console.info('Push notifications: Permission was previously denied');
            } else if (result.permission === 'default') {
                // Permission not requested yet - this is normal
                console.info('Push notifications: Permission not requested yet');
            } else if (result.error && result.error !== 'Permission denied') {
                // Only log actual errors, not permission denials
                console.warn('Push notifications:', result.error);
            }
        } catch (error) {
            console.error('Error initializing push notifications:', error);
        }
    }

    fetchPendingSalesCount = () => {
        try {
            const userData = localStorage.getItem('user');
            if (!userData) { this.setState({ pendingSalesCount: 0 }); return; }
            const user = JSON.parse(userData);
            if (!user?.accountId) { this.setState({ pendingSalesCount: 0 }); return; }

            return getSalesApprovalList({
                status: 'Pending for Approval',
                page: 1,
                pageSize: 1,
            })
                .then(result => this.setState({ pendingSalesCount: result?.pagination?.total || 0 }))
                .catch(() => this.setState({ pendingSalesCount: 0 }));
        } catch (e) {
            this.setState({ pendingSalesCount: 0 });
        }
    }

    fetchPendingPurchaseCount = () => {
        try {
            const userData = localStorage.getItem('user');
            if (!userData) { this.setState({ pendingPurchaseCount: 0 }); return; }
            const user = JSON.parse(userData);
            if (!user?.accountId) { this.setState({ pendingPurchaseCount: 0 }); return; }

            return getPurchaseApprovalList({
                status: 'Pending for Approval',
                page: 1,
                pageSize: 1,
            })
                .then(result => this.setState({ pendingPurchaseCount: result?.pagination?.total || 0 }))
                .catch(() => this.setState({ pendingPurchaseCount: 0 }));
        } catch (e) {
            this.setState({ pendingPurchaseCount: 0 });
        }
    }

    fetchPendingFinanceCount = () => {
        try {
            const userData = localStorage.getItem('user');
            if (!userData) { this.setState({ pendingFinanceCount: 0 }); return; }
            const user = JSON.parse(userData);
            if (!user?.accountId) { this.setState({ pendingFinanceCount: 0 }); return; }

            return getFinanceApprovalList({
                status: 'Pending for Approval',
                page: 1,
                pageSize: 1,
            })
                .then(result => this.setState({ pendingFinanceCount: result?.pagination?.total || 0 }))
                .catch(() => this.setState({ pendingFinanceCount: 0 }));
        } catch (e) {
            this.setState({ pendingFinanceCount: 0 });
        }
    }

    fetchPendingApprovalCount = () => {
        try {
            const userData = localStorage.getItem('user');
            if (!userData) {
                this.setState({
                    pendingApprovalCount: 0,
                    pendingCountsByType: { incoming: 0, outgoing: 0, inprogress: 0, fpbo: 0, lpbo: 0 }
                });
                return;
            }

            const user = JSON.parse(userData);
            if (!user || !user.id) {
                this.setState({
                    pendingApprovalCount: 0,
                    pendingCountsByType: { incoming: 0, outgoing: 0, inprogress: 0, fpbo: 0, lpbo: 0 }
                });
                return;
            }

            // Create abort controller for timeout
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 5000); // 5 second timeout

            // Fetch counts for each record type
            const fetchCount = (recordType) => {
                return fetch(`${config.apiUrl}/getPendingApprovalCount?approver_id=${user.id}&record_type=${recordType}`, {
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' },
                    signal: controller.signal
                })
                    .then((response) => {
                        if (!response.ok) {
                            throw new Error(`HTTP error! status: ${response.status}`);
                        }
                        return response.text().then(text => {
                            if (!text || text.trim() === '') return { count: 0 };
                            try {
                                return JSON.parse(text);
                            } catch (e) {
                                return { count: 0 };
                            }
                        });
                    })
                    .then(data => data.count || 0)
                    .catch(() => 0);
            };

            // Fetch all counts in parallel
            Promise.all([
                fetchCount('incoming'),
                fetchCount('outgoing'),
                fetchCount('inprogress'),
                fetchCount('fpbo'),
                fetchCount('lpbo'),
                fetchCount('fai')
            ])
                .then(([incomingCount, outgoingCount, inprogressCount, fpboCount, lpboCount, faiCount]) => {
                    clearTimeout(timeoutId);
                    const totalCount = incomingCount + outgoingCount + inprogressCount + fpboCount + lpboCount + faiCount;
                    this.setState({
                        pendingApprovalCount: totalCount,
                        pendingCountsByType: {
                            incoming: incomingCount,
                            outgoing: outgoingCount,
                            inprogress: inprogressCount,
                            fpbo: fpboCount,
                            lpbo: lpboCount,
                            fai: faiCount
                        }
                    });
                })
                .catch(error => {
                    clearTimeout(timeoutId);
                    if (error.name !== 'AbortError') {
                        console.warn('Error fetching pending approval counts:', error.message);
                    }
                    this.setState({
                        pendingApprovalCount: 0,
                        pendingCountsByType: { incoming: 0, outgoing: 0, inprogress: 0, fpbo: 0, lpbo: 0, fai: 0 }
                    });
                });
        } catch (error) {
            console.warn('Error in fetchPendingApprovalCount:', error);
            this.setState({
                pendingApprovalCount: 0,
                pendingCountsByType: { incoming: 0, outgoing: 0, inprogress: 0, fpbo: 0, lpbo: 0, fai: 0 }
            });
        }
    }

    handleInstallClick = async () => {
        // Use state deferredPrompt or fallback to window.deferredPrompt
        const deferredPrompt = this.state.deferredPrompt || window.deferredPrompt;
        if (!deferredPrompt) {
            console.warn('No install prompt available');
            return;
        }

        try {
            // Show the install prompt
            deferredPrompt.prompt();

            // Wait for the user to respond to the prompt
            const { outcome } = await deferredPrompt.userChoice;

            console.log(`User response to install prompt: ${outcome}`);

            // Clear the deferredPrompt
            window.deferredPrompt = null;
            this.setState({
                deferredPrompt: null,
                showInstallPrompt: false
            });
        } catch (error) {
            console.error('Error showing install prompt:', error);
            this.setState({
                deferredPrompt: null,
                showInstallPrompt: false
            });
        }
    };

    handleDismissInstall = () => {
        this.setState({ showInstallPrompt: false });
        // Store dismissal in localStorage to avoid showing again for a while
        localStorage.setItem('pwa-install-dismissed', Date.now().toString());
    };

    componentWillUnmount() {
        if (this.stopDataTableFreezeManager) {
            this.stopDataTableFreezeManager();
        }
        clearInterval(this.interval);
        if (this.countInterval) {
            clearInterval(this.countInterval);
        }
        // Remove event listener
        if (this.refreshCountsHandler) {
            window.removeEventListener('refreshPendingApprovalCounts', this.refreshCountsHandler);
        }
        // Remove PWA install prompt listeners
        if (this.handleBeforeInstallPrompt) {
            window.removeEventListener('beforeinstallprompt', this.handleBeforeInstallPrompt);
        }
        if (this.handleAppInstalled) {
            window.removeEventListener('appinstalled', this.handleAppInstalled);
        }
        if (this.handlePWAInstallAvailable) {
            window.removeEventListener('pwa-install-available', this.handlePWAInstallAvailable);
        }
    }

    render() {
        let user = {};
        try {
            const userData = localStorage.getItem('user');
            user = userData ? JSON.parse(userData) : {};
        } catch (error) {
            console.error('Error parsing user data:', error);
            user = {};
        }

        return (
            <>
                <Router>
                    <div className="app-container">
                        {this.state?.navbar && (
                            <Sidebar
                                user={user}
                                pendingApprovalCount={this.state.pendingApprovalCount}
                                pendingCountsByType={this.state.pendingCountsByType}
                                pendingSalesCount={this.state.pendingSalesCount}
                                pendingPurchaseCount={this.state.pendingPurchaseCount}
                                pendingFinanceCount={this.state.pendingFinanceCount}
                            />
                        )}

                        <main className={`main-content ${!this.state?.navbar ? 'full-width' : ''}`}>
                            <div className="container-fluid py-4" style={{ paddingBottom: '4rem' }}>
                                <Routes>
                                    <Route path="/login" element={<LoginPage />} />
                                    <Route path="/" element={<PrivateRoute><HomePage key="floor-deck" /></PrivateRoute>} />
                                    <Route path="/daily-overview" element={<PrivateRoute><HomePage key="daily-overview" pageMode="daily-overview" /></PrivateRoute>} />
                                    <Route path="/incoming_master/new" element={<PrivateRoute><IncomingMasterForm /></PrivateRoute>} />
                                    <Route path="/incoming_master/:id" element={<PrivateRoute><IncomingMasterForm /></PrivateRoute>} />
                                    <Route path="/incoming_master" element={<PrivateRoute><IncomingMaster /></PrivateRoute>} />
                                    <Route path="/inspection_list" element={<PrivateRoute><InspectionList /></PrivateRoute>} />
                                    <Route path="/test_list" element={<PrivateRoute><TestList /></PrivateRoute>} />
                                    <Route path="/incoming_summary/:id" element={<PrivateRoute><IncomingSummaryReport /></PrivateRoute>} />
                                    <Route path="/incoming_summary" element={<PrivateRoute><IncomingSummary /></PrivateRoute>} />
                                    <Route path="/inprogress_master/new" element={<PrivateRoute><InprogressMasterForm /></PrivateRoute>} />
                                    <Route path="/inprogress_master/:id" element={<PrivateRoute><InprogressMasterForm /></PrivateRoute>} />
                                    <Route path="/inprogress_master" element={<PrivateRoute><InprogressMaster /></PrivateRoute>} />
                                    <Route path="/inprogress_summary/:id" element={<PrivateRoute><InprogressSummaryReport /></PrivateRoute>} />
                                    <Route path="/inprogress_summary" element={<PrivateRoute><InprogressSummary /></PrivateRoute>} />
                                    <Route path="/fpbo_summary/:id" element={<PrivateRoute><FpboSummaryReport /></PrivateRoute>} />
                                    <Route path="/fpbo_summary" element={<PrivateRoute><FpboSummary /></PrivateRoute>} />
                                    <Route path="/lpbo_summary/:id" element={<PrivateRoute><LpboSummaryReport /></PrivateRoute>} />
                                    <Route path="/lpbo_summary" element={<PrivateRoute><LpboSummary /></PrivateRoute>} />
                                    <Route path="/fai_master/new" element={<PrivateRoute><FaiMasterForm /></PrivateRoute>} />
                                    <Route path="/fai_master/:id" element={<PrivateRoute><FaiMasterForm /></PrivateRoute>} />
                                    <Route path="/fai_master" element={<PrivateRoute><FaiMaster /></PrivateRoute>} />
                                    <Route path="/fai_summary/:id" element={<PrivateRoute><FaiSummaryReport /></PrivateRoute>} />
                                    <Route path="/fai_summary" element={<PrivateRoute><FaiSummary /></PrivateRoute>} />
                                    <Route path="/waiting-for-inspection" element={<PrivateRoute><WaitingForInspection /></PrivateRoute>} />
                                    <Route path="/waiting-for-inspection/fpbo/:id" element={<PrivateRoute><FpboSummaryReport readOnly /></PrivateRoute>} />
                                    <Route path="/waiting-for-inspection/lpbo/:id" element={<PrivateRoute><LpboSummaryReport readOnly /></PrivateRoute>} />
                                    <Route path="/waiting-for-inspection/fai/:id" element={<PrivateRoute><FaiSummaryReport readOnly /></PrivateRoute>} />
                                    <Route path="/outgoing_master/new" element={<PrivateRoute><OutgoingMasterForm /></PrivateRoute>} />
                                    <Route path="/outgoing_master/:id" element={<PrivateRoute><OutgoingMasterForm /></PrivateRoute>} />
                                    <Route path="/outgoing_master" element={<PrivateRoute><OutgoingMaster /></PrivateRoute>} />
                                    <Route path="/outgoing_summary/:id" element={<PrivateRoute><OutgoingSummaryReport /></PrivateRoute>} />
                                    <Route path="/outgoing_summary" element={<PrivateRoute><OutgoingSummary /></PrivateRoute>} />
                                    <Route path="/planning" element={<PrivateRoute><Planning /></PrivateRoute>} />
                                    <Route path="/clear-to-build" element={<PrivateRoute><ClearToBuild /></PrivateRoute>} />
                                    <Route path="/mrp" element={<PrivateRoute><MRP /></PrivateRoute>} />
                                    <Route path="/upload" element={<PrivateRoute><Upload /></PrivateRoute>} />
                                    <Route path="/masterdata" element={<PrivateRoute><MasterData /></PrivateRoute>} />
                                    <Route path="/newpartcreation" element={<PrivateRoute><NewPartCreation /></PrivateRoute>} />
                                    <Route path="/revision-history" element={<PrivateRoute><RevisionHistory /></PrivateRoute>} />
                                    <Route path="/tooling/master-data" element={<PrivateRoute>{canAccessToolingManagement(user) ? <ToolingMasterData /> : <Navigate to="/" replace />}</PrivateRoute>} />
                                    <Route path="/tooling/maintenance-summary/:id" element={<PrivateRoute>{canAccessToolingManagement(user) ? <ToolingMaintenanceForm /> : <Navigate to="/" replace />}</PrivateRoute>} />
                                    <Route path="/tooling/maintenance-summary" element={<PrivateRoute>{canAccessToolingManagement(user) ? <ToolingMaintenanceSummary /> : <Navigate to="/" replace />}</PrivateRoute>} />
                                    <Route path="/tooling/tpm" element={<PrivateRoute>{canAccessToolingManagement(user) ? <ToolingTPM /> : <Navigate to="/" replace />}</PrivateRoute>} />
                                    <Route path="/tooling/tpm/checklist/new" element={<PrivateRoute>{canAccessToolingManagement(user) ? <TpmChecklistForm /> : <Navigate to="/" replace />}</PrivateRoute>} />
                                    <Route path="/tooling/tpm/checklist/:id" element={<PrivateRoute>{canAccessToolingManagement(user) ? <TpmChecklistForm /> : <Navigate to="/" replace />}</PrivateRoute>} />
                                    <Route path="/tooling/tpm/maintenance/:id" element={<PrivateRoute>{canAccessToolingManagement(user) ? <TpmMaintenanceDetail /> : <Navigate to="/" replace />}</PrivateRoute>} />
                                    <Route path="/bomlist/:planningId" element={<PrivateRoute><BomList /></PrivateRoute>} />
                                    <Route path="/datamanagement" element={<PrivateRoute><DataManagement /></PrivateRoute>} />
                                    <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
                                    <Route path="/changepassword" element={<PrivateRoute><ChangePassword /></PrivateRoute>} />
                                    <Route path="/targets" element={<PrivateRoute><Targets /></PrivateRoute>} />
                                    <Route path="/settings" element={<PrivateRoute><Setting /></PrivateRoute>} />
                                    <Route path="/currency-settings" element={<PrivateRoute><CurrencySettings /></PrivateRoute>} />
                                    <Route path="/user-settings" element={<PrivateRoute><UserSettings /></PrivateRoute>} />
                                    <Route path="/role-settings" element={<Navigate to="/user-settings" replace />} />
                                    <Route path="/master-raw-material" element={<PrivateRoute>{canAccessInventoryPortalItem(user, 'master-raw-material') ? <MasterRawMaterial /> : <Navigate to="/" replace />}</PrivateRoute>} />
                                    <Route path="/master-finished-goods" element={<PrivateRoute>{canAccessInventoryPortalItem(user, 'master-finished-goods') ? <MasterFinishedGoods /> : <Navigate to="/" replace />}</PrivateRoute>} />
                                    <Route path="/master-location" element={<PrivateRoute>{canAccessInventoryPortalItem(user, 'master-location') ? <MasterLocation /> : <Navigate to="/" replace />}</PrivateRoute>} />
                                    <Route path="/activate-storage" element={<PrivateRoute>{canAccessInventoryPortalItem(user, 'activate-storage') ? <ActivateStorage /> : <Navigate to="/" replace />}</PrivateRoute>} />
                                    <Route path="/activate-rm-storage" element={<PrivateRoute>{canAccessInventoryPortalItem(user, 'activate-storage') ? <ActivateStorage /> : <Navigate to="/" replace />}</PrivateRoute>} />
                                    <Route path="/activate-fg-storage" element={<PrivateRoute>{canAccessInventoryPortalItem(user, 'activate-storage') ? <ActivateStorage /> : <Navigate to="/" replace />}</PrivateRoute>} />
                                    <Route path="/receiving-summary/:id" element={<PrivateRoute>{canAccessInventoryPortalItem(user, 'receiving-summary') ? <ReceivingSummaryReport /> : <Navigate to="/" replace />}</PrivateRoute>} />
                                    <Route path="/receiving-summary" element={<PrivateRoute>{canAccessInventoryPortalItem(user, 'receiving-summary') ? <ReceivingSummary /> : <Navigate to="/" replace />}</PrivateRoute>} />
                                    <Route path="/rm-transfer-summary/:id" element={<PrivateRoute>{canAccessInventoryPortalItem(user, 'rm-transfer-summary') ? <RMTransferSummaryReport /> : <Navigate to="/" replace />}</PrivateRoute>} />
                                    <Route path="/rm-transfer-summary" element={<PrivateRoute>{canAccessInventoryPortalItem(user, 'rm-transfer-summary') ? <RMTransferSummary /> : <Navigate to="/" replace />}</PrivateRoute>} />
                                    <Route path="/fg-transfer-summary/:id" element={<PrivateRoute>{canAccessInventoryPortalItem(user, 'fg-transfer-summary') ? <FGTransferSummaryReport /> : <Navigate to="/" replace />}</PrivateRoute>} />
                                    <Route path="/fg-transfer-summary" element={<PrivateRoute>{canAccessInventoryPortalItem(user, 'fg-transfer-summary') ? <FGTransferSummary /> : <Navigate to="/" replace />}</PrivateRoute>} />
                                    <Route path="/fg-delivery-summary/:id" element={<PrivateRoute>{canAccessInventoryPortalItem(user, 'fg-transfer-summary') ? <FGDeliverySummaryReport /> : <Navigate to="/" replace />}</PrivateRoute>} />
                                    <Route path="/fg-delivery-summary" element={<PrivateRoute>{canAccessInventoryPortalItem(user, 'fg-transfer-summary') ? <FGDeliverySummary /> : <Navigate to="/" replace />}</PrivateRoute>} />
                                    <Route path="/scrapping-summary/:id" element={<PrivateRoute>{canAccessInventoryPortalItem(user, 'scrapping-summary') ? <ScrappingSummaryReport /> : <Navigate to="/" replace />}</PrivateRoute>} />
                                    <Route path="/scrapping-summary" element={<PrivateRoute>{canAccessInventoryPortalItem(user, 'scrapping-summary') ? <ScrappingSummary /> : <Navigate to="/" replace />}</PrivateRoute>} />
                                    <Route path="/inventory-status-overview" element={<PrivateRoute>{canAccessInventoryPortalItem(user, 'inventory-status-overview') ? <InventoryStatusOverview /> : <Navigate to="/" replace />}</PrivateRoute>} />
                                    <Route path="/inventory-bom-usage-report" element={<PrivateRoute>{canAccessInventoryPortalItem(user, 'reports-all') ? <BomUsageByJobReport /> : <Navigate to="/" replace />}</PrivateRoute>} />
                                    <Route path="/inventory-status-report" element={<PrivateRoute>{canAccessInventoryPortalItem(user, 'reports-all') ? <InventoryStatusReport /> : <Navigate to="/" replace />}</PrivateRoute>} />
                                    <Route path="/admindashboard" element={<PrivateRoute><AdminDashboard /></PrivateRoute>} />
                                    <Route path="/hourlyreport" element={<PrivateRoute><HourlyReport /></PrivateRoute>} />
                                    <Route path="/jobOrderSummaryReport" element={<PrivateRoute><JobOrderSummaryReport /></PrivateRoute>} />
                                    <Route path="/dailyoeereport" element={<PrivateRoute><DailyOEEReport /></PrivateRoute>} />
                                    <Route path="/dailyproductivityreport" element={<PrivateRoute><DailyProductivityReport /></PrivateRoute>} />
                                    <Route path="/monthlyoeereport" element={<PrivateRoute><MonthlyOEEReport /></PrivateRoute>} />
                                    <Route path="/monthlyproductivityreport" element={<PrivateRoute><MonthlyProductivityReport /></PrivateRoute>} />
                                    <Route path="/rm-warehouse-occupancy-report" element={<PrivateRoute>{canAccessInventoryPortalItem(user, 'reports-all') ? <RMWarehouseOccupancyReport /> : <Navigate to="/" replace />}</PrivateRoute>} />
                                    <Route path="/fg-warehouse-occupancy-report" element={<PrivateRoute>{canAccessInventoryPortalItem(user, 'reports-all') ? <FGWarehouseOccupancyReport /> : <Navigate to="/" replace />}</PrivateRoute>} />
                                    <Route path="/doccon/manufacturing" element={<PrivateRoute><DocCon docType={DOC_TYPE_IDS.MANUFACTURING} /></PrivateRoute>} />
                                    <Route path="/doccon/drawing" element={<PrivateRoute><DocCon docType={DOC_TYPE_IDS.PROCESS_DRAWING} /></PrivateRoute>} />
                                    <Route path="/doccon/quality" element={<PrivateRoute><DocCon docType={DOC_TYPE_IDS.QUALITY_INSTRUCTION} /></PrivateRoute>} />
                                    <Route path="/doccon/flow" element={<PrivateRoute><DocCon docType={DOC_TYPE_IDS.PROCESS_FLOW} /></PrivateRoute>} />
                                    <Route path="/doccon/control" element={<PrivateRoute><DocCon docType={DOC_TYPE_IDS.CONTROL_PLAN} /></PrivateRoute>} />
                                    <Route path="/doccon/parameter" element={<PrivateRoute><DocCon docType={DOC_TYPE_IDS.PARAMETER} /></PrivateRoute>} />
                                    {/* Sales — Customer */}
                                    <Route path="/contacts/customers" element={
                                        <PrivateRoute>
                                            {(canAccessSalesModule(user) || canAccessAccounting(user) || isSuperAdmin(user))
                                                ? <Customers />
                                                : <Navigate to="/" replace />}
                                        </PrivateRoute>
                                    } />
                                    <Route path="/contacts/customers/:id" element={
                                        <PrivateRoute>
                                            {(canAccessSalesModule(user) || canAccessAccounting(user) || isSuperAdmin(user))
                                                ? <CustomerDetails />
                                                : <Navigate to="/" replace />}
                                        </PrivateRoute>
                                    } />

                                    {/* Sales — Quotation: BUU + BUM + Accountant + Admin only */}
                                    <Route path="/sales/quotations" element={
                                        <PrivateRoute>
                                            {(isBusinessUnitUser(user) || isBusinessUnitManager(user) || canAccessAccounting(user) || isSuperAdmin(user))
                                                ? <Quotations />
                                                : <Navigate to="/" replace />}
                                        </PrivateRoute>
                                    } />
                                    <Route path="/sales/quotations/:id" element={
                                        <PrivateRoute>
                                            {(isBusinessUnitUser(user) || isBusinessUnitManager(user) || canAccessAccounting(user) || isSuperAdmin(user))
                                                ? <QuotationDetails />
                                                : <Navigate to="/" replace />}
                                        </PrivateRoute>
                                    } />

                                    {/* Sales — Sales Order: BUU + BUM + Accountant + Admin only */}
                                    <Route path="/sales/sales-orders" element={
                                        <PrivateRoute>
                                            {(isBusinessUnitUser(user) || isBusinessUnitManager(user) || canAccessAccounting(user) || isSuperAdmin(user))
                                                ? <SalesOrders />
                                                : <Navigate to="/" replace />}
                                        </PrivateRoute>
                                    } />
                                    <Route path="/sales/sales-orders/:id" element={
                                        <PrivateRoute>
                                            {(isBusinessUnitUser(user) || isBusinessUnitManager(user) || canAccessAccounting(user) || isSuperAdmin(user))
                                                ? <SalesOrderDetails />
                                                : <Navigate to="/" replace />}
                                        </PrivateRoute>
                                    } />

                                    {/* Sales — Invoice: Shipping + BUM + Accountant + Admin only */}
                                    <Route path="/sales/invoices" element={
                                        <PrivateRoute>
                                            {(isShippingUser(user) || isBusinessUnitManager(user) || canAccessAccounting(user) || isSuperAdmin(user))
                                                ? <Invoices />
                                                : <Navigate to="/" replace />}
                                        </PrivateRoute>
                                    } />
                                    <Route path="/sales/invoices/:id" element={
                                        <PrivateRoute>
                                            {(isShippingUser(user) || isBusinessUnitManager(user) || canAccessAccounting(user) || isSuperAdmin(user))
                                                ? <InvoiceDetails />
                                                : <Navigate to="/" replace />}
                                        </PrivateRoute>
                                    } />

                                    {/* Sales — Delivery Order: Shipping + BUM + Accountant + Admin only */}
                                    <Route path="/sales/delivery-orders" element={
                                        <PrivateRoute>
                                            {(isShippingUser(user) || isBusinessUnitManager(user) || canAccessAccounting(user) || isSuperAdmin(user))
                                                ? <DeliveryOrders />
                                                : <Navigate to="/" replace />}
                                        </PrivateRoute>
                                    } />
                                    <Route path="/sales/delivery-orders/:id" element={
                                        <PrivateRoute>
                                            {(isShippingUser(user) || isBusinessUnitManager(user) || canAccessAccounting(user) || isSuperAdmin(user))
                                                ? <DeliveryOrderDetails />
                                                : <Navigate to="/" replace />}
                                        </PrivateRoute>
                                    } />

                                    {/* Sales — Approvals: BUM + Accountant + Admin only */}
                                    <Route path="/accounting-approvals/sales-approvals" element={
                                        <PrivateRoute>
                                            {(isBusinessUnitManager(user) || canAccessAccounting(user) || isSuperAdmin(user))
                                                ? <SalesApprovals />
                                                : <Navigate to="/" replace />}
                                        </PrivateRoute>
                                    } />
                                    {/* Purchase — Supplier: Purchasing User + Purchasing Manager + Accountant + Admin */}
                                    <Route path="/contacts/suppliers" element={
                                        <PrivateRoute>
                                            {(canAccessPurchaseModule(user) || canAccessAccounting(user) || isSuperAdmin(user))
                                                ? <Suppliers />
                                                : <Navigate to="/" replace />}
                                        </PrivateRoute>
                                    } />
                                    <Route path="/contacts/suppliers/:id" element={
                                        <PrivateRoute>
                                            {(canAccessPurchaseModule(user) || canAccessAccounting(user) || isSuperAdmin(user))
                                                ? <SupplierDetails />
                                                : <Navigate to="/" replace />}
                                        </PrivateRoute>
                                    } />

                                    {/* Purchase — Purchase Order: Purchasing User + Purchasing Manager + Accountant + Admin */}
                                    <Route path="/purchases/purchase-orders" element={
                                        <PrivateRoute>
                                            {(isPurchasingUser(user) || isPurchasingManager(user) || canAccessAccounting(user) || isSuperAdmin(user))
                                                ? <PurchaseOrders />
                                                : <Navigate to="/" replace />}
                                        </PrivateRoute>
                                    } />
                                    <Route path="/purchases/purchase-orders/:id" element={
                                        <PrivateRoute>
                                            {(isPurchasingUser(user) || isPurchasingManager(user) || canAccessAccounting(user) || isSuperAdmin(user))
                                                ? <PurchaseOrderDetails />
                                                : <Navigate to="/" replace />}
                                        </PrivateRoute>
                                    } />

                                    {/* Purchase — Approvals: Purchasing Manager + Accountant + Admin only */}
                                    <Route path="/accounting-approvals/purchase-approvals" element={
                                        <PrivateRoute>
                                            {(isPurchasingManager(user) || canAccessAccounting(user) || isSuperAdmin(user))
                                                ? <PurchasingApprovals />
                                                : <Navigate to="/" replace />}
                                        </PrivateRoute>
                                    } />
                                    {/* Accounting & Finance: Accountant + Admin + QC Admin (with allowAccounting) only */}
                                    {[
                                        ["/finance/direct-purchase-invoices", <DirectPurchaseInvoices />],
                                        ["/finance/direct-purchase-invoices/:id", <DirectPurchaseInvoiceDetails />],
                                        ["/finance/indirect-purchase-invoices", <IndirectPurchaseInvoices />],
                                        ["/finance/indirect-purchase-invoices/:id", <IndirectPurchaseInvoiceDetails />],
                                        ["/finance/payment-vouchers", <PaymentVouchers />],
                                        ["/finance/payment-vouchers/:id", <PaymentVoucherDetails />],
                                        ["/finance/purchase-credit-notes", <PurchaseCreditNotes />],
                                        ["/finance/purchase-credit-notes/:id", <PurchaseCreditNoteDetails />],
                                        ["/finance/purchase-debit-notes", <PurchaseDebitNotes />],
                                        ["/finance/purchase-debit-notes/:id", <PurchaseDebitNoteDetails />],
                                        ["/finance/credit-notes", <CreditNotes />],
                                        ["/finance/credit-notes/:id", <CreditNoteDetails />],
                                        ["/finance/debit-notes", <DebitNotes />],
                                        ["/finance/debit-notes/:id", <DebitNoteDetails />],
                                        ["/accounting-approvals/finance-approvals", <FinanceApprovals />],
                                    ].map(([path, element]) => (
                                        <Route key={path} path={path} element={
                                            <PrivateRoute>
                                                {(canAccessAccounting(user) || isSuperAdmin(user))
                                                    ? element
                                                    : <Navigate to="/" replace />}
                                            </PrivateRoute>
                                        } />
                                    ))}
                                    {/* Contacts — company (Finance module only) */}
                                    <Route path="/contacts/company" element={<PrivateRoute><Company /></PrivateRoute>} />
                                    <Route path="/costing/*" element={<PrivateRoute><ComingSoon label="Costing" /></PrivateRoute>} />
                                    <Route path="*" element={<Navigate to="/login" />} />
                                </Routes>
                            </div>
                            <footer
                                className="elexer-app-footer mt-auto"
                                style={{
                                    padding: '16px 20px',
                                    textAlign: 'center',
                                    fontSize: '13px',
                                    fontWeight: 500,
                                    color: '#a2a3b7',
                                    borderTop: '1px solid #ebedf3',
                                }}
                            >
                                Elexer Dashboard · v{APP_VERSION}
                            </footer>
                        </main>
                    </div>
                    {/* TODO: Remove the account checking once the testing is done */}
                    {this.state?.navbar && Number(user?.accountId) === 1 && (
                        <AIChatWidget user={user} />
                    )}
                </Router>
                {/* PWA Install Prompt - Chrome/Edge/Firefox */}
                {this.state.showInstallPrompt && !this.state.isSafari && (
                    <div
                        style={{
                            position: 'fixed',
                            bottom: 52,
                            right: 20,
                            backgroundColor: '#fff',
                            border: '1px solid #ddd',
                            borderRadius: '8px',
                            padding: '16px',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                            zIndex: 9999,
                            maxWidth: '320px',
                            animation: 'slideInUp 0.3s ease-out'
                        }}
                    >
                        <style>
                            {`
                            @keyframes slideInUp {
                                from {
                                    transform: translateY(100%);
                                    opacity: 0;
                                }
                                to {
                                    transform: translateY(0);
                                    opacity: 1;
                                }
                            }
                        `}
                        </style>
                        <div style={{ marginBottom: '12px' }}>
                            <strong>Install Elexer Dashboard</strong>
                            <p style={{ margin: '8px 0 0 0', fontSize: '14px', color: '#666' }}>
                                Install this app on your device for a better experience!
                            </p>
                        </div>
                        <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                            <button
                                className="btn btn-outline-secondary btn-sm"
                                onClick={this.handleDismissInstall}
                                style={{ fontSize: '12px' }}
                            >
                                Not Now
                            </button>
                            <button
                                className="btn btn-primary btn-sm"
                                onClick={this.handleInstallClick}
                                style={{ fontSize: '12px' }}
                            >
                                Install
                            </button>
                        </div>
                    </div>
                )}

                {/* Safari/iOS Install Instructions */}
                {this.state.showSafariInstructions && (
                    <div
                        style={{
                            position: 'fixed',
                            bottom: 52,
                            right: 20,
                            backgroundColor: '#fff',
                            border: '1px solid #ddd',
                            borderRadius: '8px',
                            padding: '16px',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                            zIndex: 9999,
                            maxWidth: '320px',
                            animation: 'slideInUp 0.3s ease-out'
                        }}
                    >
                        <style>
                            {`
                            @keyframes slideInUp {
                                from {
                                    transform: translateY(100%);
                                    opacity: 0;
                                }
                                to {
                                    transform: translateY(0);
                                    opacity: 1;
                                }
                            }
                        `}
                        </style>
                        <div style={{ marginBottom: '12px' }}>
                            <strong>Install Elexer Dashboard</strong>
                            <p style={{ margin: '8px 0 0 0', fontSize: '14px', color: '#666' }}>
                                {this.state.isIOS ? (
                                    <>
                                        Tap the <strong>Share</strong> button <span style={{ fontSize: '18px' }}>📤</span> at the bottom,
                                        then select <strong>"Add to Home Screen"</strong>
                                    </>
                                ) : (
                                    <>
                                        Click the <strong>Share</strong> button <span style={{ fontSize: '18px' }}>📤</span> in Safari,
                                        then select <strong>"Add to Dock"</strong> or <strong>"Add to Home Screen"</strong>
                                    </>
                                )}
                            </p>
                        </div>
                        <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                            <button
                                className="btn btn-outline-secondary btn-sm"
                                onClick={() => {
                                    this.setState({ showSafariInstructions: false });
                                    // Store dismissal in localStorage (7 days)
                                    localStorage.setItem('pwa-safari-instructions-dismissed', Date.now().toString());
                                }}
                                style={{ fontSize: '12px' }}
                            >
                                Dismiss
                            </button>
                        </div>
                    </div>
                )}
            </>
        );
    }
}

export { App };
